export default __webpack_public_path__ + "static/media/avatar.f9d244e5.png";